import { DocumentCategoryWithTagsResponse } from "apis/data-contracts";
import { LeftIcon } from "assets/icons";
import Board from "components/Common/Board/Board";
import MobilePageCover from "components/Common/MobilePageCover/MobilePageCover";
import Button from "components/foundation/Button";
import Divider from "components/foundation/Divider";
import TagList from "components/foundation/Tag/TagList";
import { ROUTER_PATH } from "config/path";
import { useDocumentClassesByCategoryQuery } from "features/document/hooks/queries/useDocumentClassesByCategoryQuery";
import TagPageListItem from "pages/tag/TagPageListItem";
import React from "react";
import { Link, useNavigate } from "react-router-dom";
import styled from "styled-components";

interface TagDetailMobilePageProps {
  data: DocumentCategoryWithTagsResponse;
  id: string;
}

const TagDetailMobilePage = ({ data, id }: TagDetailMobilePageProps) => {
  const navigate = useNavigate();

  const { data: documentClasses } = useDocumentClassesByCategoryQuery(id);

  return (
    <MobilePageCover header={<LeftIcon onClick={() => navigate(-1)} />}>
      <TagDetailPageLayout>
        <h1>태그조회</h1>
        <TagPageListItem title="문서종류">
          <p>{data.documentCategoryName}</p>
        </TagPageListItem>
        <Divider />

        <TagPageListItem title="문서구분태그">
          <TagList
            list={documentClasses.map((documentClass) => documentClass.name)}
          />
        </TagPageListItem>
        {data.tagCategories.map((tag) => {
          return (
            <TagPageListItem
              title={tag.tagCategoryName}
              key={tag.tagCategoryUuid}
            >
              <TagList list={tag.tags.map((i) => i.tagName)} />
            </TagPageListItem>
          );
        })}
        <Link to={ROUTER_PATH.tag.dashboard.detail.edit(id)}>
          <Button size="large">수정</Button>
        </Link>
      </TagDetailPageLayout>
    </MobilePageCover>
  );
};

export default TagDetailMobilePage;

const TagDetailPageLayout = styled(Board)`
  display: flex;
  flex-direction: column;
  padding: 1.6rem;
  gap: 2rem;

  h1 {
    ${({ theme }) => theme.typography.t1.semibold};
  }

  button {
    width: -webkit-fill-available;
  }
`;
